import { Inject, Injectable, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { AuthService } from '@klickdata/core/auth';
import { Customer } from '@klickdata/core/customer';
import { AppScope, ResourceTypes } from '@klickdata/core/resource';
import { map, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
@Pipe({
    name: 'resourceDefaultNameDisplay',
})
export class ResourceDefaultNameDisplayPipe implements PipeTransform {
    private cachedCustomer: Customer = null;
    constructor(private auth: AuthService, @Inject(LOCALE_ID) protected localeId: string) {
        this.localeId = localeId === 'en' ? 'en-US' : localeId;
    }

    transform(resource: any, plural: boolean, nameTranslation?: string): Observable<string> {
        if (!resource) {
            return of('');
        }
        const scope = resource.scope_id ?? ResourceTypes.scopeByChildType(resource.type_id);

        const name =
            nameTranslation ??
            resource.user_collaboration?.view?.metadata?.name_translation?.[this.localeId] ??
            resource.collaboration?.view?.metadata?.name_translation?.[this.localeId];

        if (this.cachedCustomer) {
            return of(name ?? this.cachedCustomer.scope_names[scope] ?? AppScope.label(scope, plural));
        }
        return this.auth.getCustomer().pipe(
            map((customer) => {
                this.cachedCustomer = customer;
                return name ?? this.cachedCustomer.scope_names[scope] ?? AppScope.label(scope, plural);
            })
        );
    }
}
